

const loginForm = document.querySelector('form[action="/account/login"]');
const loginBtn  = loginForm?.querySelector('button[type="submit"]');
const emailField = loginForm?.querySelector('input[name="customer[email]"]');

if (loginForm) {
  loginForm.addEventListener("submit", e => {

    console.log("🔐 LOGIN SUBMITTED");

    // Basic check
    if (!emailField.value.trim()) {
      e.preventDefault();
      alert("Please enter your email address");
      return;
    }

    // Lock button
    loginBtn.disabled = true;
    loginBtn.innerText = "Logging in...";

  });
}

